export const PACKAGE_NAME = 'jiraIssueFieldStatistics';

export const NUMERIC_FIELD_STATISTICS_ANALYTICS_ID = 'getNumericFieldStatistics';
